export const LOAD_DICTIONARY   = 'LOAD_DICTIONARY'
export const DICTIONARY_FAIL   = 'DICTIONARY_FAIL'
